import UsersGalleryTopSection from 'components/Community/UsersGallery/UsersGalleryTopSection/UsersGalleryTopSection';

export default UsersGalleryTopSection;
